import React from "react";
import {
    Autocomplete,
    Grid,
    TextField,
} from "@mui/material";
import Labels from "../labels/Labels";

const CustomFieldRenderer = ({ customField, formik }) => {
    const fieldData = formik.values.customFields?.[customField.key];
    // For TEXT/NUMBER fields, fieldData is a string. For SELECT fields, fieldData is the complete option object
    const fieldValue = typeof fieldData === 'object' ? fieldData?.value || '' : fieldData || '';
    
    // Show error if field is touched (same as normal fields)
    const shouldShowError = formik.touched.customFields?.[customField.key];
    const hasError = shouldShowError && Boolean(formik.errors.customFields?.[customField.key]);
    const errorMessage = shouldShowError && formik.errors.customFields?.[customField.key];
    
    // Custom onBlur handler that marks the field as touched
    const handleBlur = () => {
        formik.setFieldTouched(`customFields.${customField.key}`, true);
    };

    const commonProps = {
        fullWidth: true,
        id: `customFields.${customField.key}`,
        name: `customFields.${customField.key}`,
        label: Labels.getLabel(customField.key, customField.key),
        value: fieldValue,
        onChange: formik.handleChange,
        onBlur: handleBlur,
        error: hasError,
        helperText: errorMessage,
    };

    const renderCustomFieldByType = () => {
        switch (customField.type) {
            case 'TEXT':
                return (
                    <TextField
                        {...commonProps}
                        inputProps={{ maxLength: customField.validation?.maxLength }}
                    />
                );
            case 'NUMBER':
                return (
                    <TextField
                        {...commonProps}
                        type="number"
                        inputProps={{ maxLength: customField.validation?.maxLength }}
                    />
                );
            case 'SELECT':
                return (
                    <Autocomplete
                        id={`customFields.${customField.key}`}
                        options={customField.options || []}
                        getOptionLabel={(option) => {
                            if (typeof option === 'string') return option;
                            return option.label || option.description || option.value || '';
                        }}
                        value={formik.values.customFields?.[customField.key] || null}
                        onChange={(event, newValue) => {
                            // Store the complete object like MccListSelector stores complete MCC objects
                            formik.setFieldValue(`customFields.${customField.key}`, newValue);
                        }}
                        onBlur={handleBlur}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={Labels.getLabel(customField.key, customField.key)}
                                error={hasError}
                                helperText={errorMessage}
                                onBlur={handleBlur}
                                name={`customFields.${customField.key}`}
                            />
                        )}
                    />
                );
            default:
                return <TextField {...commonProps} />;
        }
    };

    return (
        <Grid item xs={12} md={6} key={customField.key}>
            {renderCustomFieldByType()}
        </Grid>
    );
};

export default CustomFieldRenderer;